import "./button.css";
import "./steps.css";
import prepareImage from "./XBloomPrepare.png";
import weighingImage from "./XBloomWeighing.png";
import beansImage from "./pourBeans.png";
import ProgressBar from "./ProgressBar";
import { useEffect, useState } from "react";

export const S1Prepare: React.FC = () => {
  return (
    <>
      <img
        className="stepImage"
        src={prepareImage}
        alt="Prepare the coffee machine"
      />
      <div className="step">
        <h1>1. Prepare the coffee machine</h1>
        <h2>
          Ensure there is Water in the water tank and there is no used coffee
          filter in the machines holder.
        </h2>
        <h2>
          Put a <b>clean</b> filter into the holder and place your cup under the
          holder on the right side of the tray.
        </h2>
      </div>
    </>
  );
};

type WeighBeanProps = {
  weight: number;
  tare: () => void;
};

export const S2WeightBeans: React.FC<WeighBeanProps> = ({ weight, tare }) => {
  const [internalWeight, setInternalWeight] = useState(weight);
  useEffect(() => {
    setInternalWeight(weight);
  }, [weight]);
  return (
    <>
      <img
        className="stepImage"
        src={weighingImage}
        alt="Prepare the coffee machine"
      />

      <div className="step">
        <h1>2. Weight the coffee beans</h1>
        <h2>Weigh 15 grams of the coffee of your choice. </h2>
        <ProgressBar progress={internalWeight} target={15.0} />
        <button className="button" onClick={tare}>
          Tare
        </button>
      </div>
    </>
  );
};

type SelectProfileProps = {
  profiles: string[];
  onSelect: (profile: string) => void;
};

export const S3ChooseProfile: React.FC<SelectProfileProps> = ({
  profiles,
  onSelect,
}) => {
  const [clicked, setClicked] = useState(false);
  const handleClick = (profile: string) => {
    setClicked(true);
    onSelect(profile);

    setTimeout(() => {
      setClicked(false);
    }, 10000);
  };
  return (
    <>
      <img
        className="stepImage"
        src={beansImage}
        alt="Bour Beans into coffee machine"
      />

      <div className="step">
        <h1>3. Pour the coffee into the xBlooms grinder opening </h1>

        <h1>Select your coffee profile</h1>
        
        {profiles.map((profile) => (
          <button
            className="button"
            key={profile}
            onClick={() => handleClick(profile)}
          >
            {clicked? "Sending profile. Please wait (around 5 seconds)":profile}
          </button>
        ))}
      </div>
    </>
  );
};

type StartBrewingProps = {
  onClick: () => void;
};

export const S4StartBrewing: React.FC<StartBrewingProps> = ({ onClick }) => {
  return (
    <div className="step">
      <h1>4. Did the machine load the profile?</h1>
      <button className="button" onClick={onClick}>
        Click To start Brewing
      </button>
    </div>
  );
};

export const S5Brewing: React.FC<StartBrewingProps> = ({ onClick }) => {
  return (
    <div className="step">
      <h1>5. Brewing (Estimate 4 minutes)</h1>
      <button className="button" onClick={onClick}>
        PAUSE / STOP / ABORT / AHHHHHH
      </button>
    </div>
  );
};
